// extracted by mini-css-extract-plugin
export default {"backLink":"backLink_backLink__+w0f9"};